<template>
    <div class="fs5-earnings-card" >
        <div
            class="fs5-earnings-card-title"
            v-html="view.title"
        ></div>
        <div class="fs5-earnings-card-content1">
            <div
                class="c1-row"
                v-for="(item, index) in view.content1" :key="index"
            >
                <div
                    class="text"
                    v-html="item.text"
                ></div>
                <div
                    class="value"
                    v-html="item.value"
                ></div>
            </div>
        </div>
        <div class="fs5-earnings-card-content2">
            <div
                class="c2-row"
                v-for="(item, index) in view.content2" :key="index"
            >
                <div
                    class="text"
                    v-html="item.text"
                ></div>
                <div
                    class="value"
                    v-html="item.value"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fs5-earnings-card',
        props: {
            view: {
                type: Object,
                default: function () {
                    return {
                        title: 'Title',
                        content1: [
                            {
                                text: 'All Leads',
                                value: 32
                            },
                            {
                                text: 'All Active Leads',
                                value: 68
                            },
                            {
                                text: 'Number Of All Affiliates',
                                value: 99
                            },
                        ],
                        content2: [
                            {
                                text: 'USD',
                                value: '$35,99'
                            },
                            {
                                text: 'EUR',
                                value: '€34,99'
                            },
                            {
                                text: 'BRL',
                                value: 'R$35,99'
                            },
                        ]
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-earnings-card{
        font: inherit;
        background-color: $fs5-color2;
        border: 1px $fs5-color1 solid;
        border-radius: 0.8em;
        padding: 2.8em 4.1em 2.1em 4.1em;
        text-align: center;

        .fs5-earnings-card-title{
            font: inherit;
            font-size: 2.5em;
            line-height: 1.2;
            color: $fs5-color11;
            text-transform: capitalize;
            text-align: center;
            margin-bottom: 1.32em; // 33px
        }
        .fs5-earnings-card-content1{
            font: inherit;
            margin-bottom: 4.7em;
            .c1-row{
                font: inherit;
                display: flex;
                justify-content: space-between;
                align-items: center;
                column-gap: 0.5em;
                padding: 1.4em 0 1.7em 0;

                border-bottom: 1px $fs5-color1 solid;

                &:last-child{
                    border-bottom: none;
                }

                .text{
                    font: inherit;
                    font-size: 1.6em;
                    font-weight: 700;
                    line-height: 1.2;
                    color: $fs5-color15;
                    text-align: left;
                }
                .value{
                    font: inherit;
                    font-size: 1.6em;
                    font-weight: 700;
                    line-height: 1.2;
                    color: $fs5-color10; 
                    text-align: right;
                }
            }
        }
        .fs5-earnings-card-content2{
            font: inherit;
            .c2-row{
                font: inherit;
                display: flex;
                justify-content: space-between;
                align-items: center;
                column-gap: 0.5em;
                padding: 0.4em 0 0.7em 0;

                border-bottom: 1px $fs5-color1 solid;

                &:last-child{
                    border-bottom: none;
                }

                .text{
                    font: inherit;
                    font-size: 1.6em;
                    font-weight: 800;
                    line-height: 1.2;
                    color: $fs5-color10;
                    text-align: left;
                }
                .value{
                    font: inherit;
                    font-size: 1.6em;
                    font-weight: 800;
                    line-height: 1.2;
                    color: $fs5-color16;
                    text-align: right;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/tools/card/EarningsCard.vue